import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Input from '@lightspeed/cirrus-input';
import Group from '@lightspeed/cirrus-group';

import Skeleton from './Skeleton';

function renderParameters(parameters) {
  return parameters.map(parameter => (
    <Field
      key={parameter.id}
      name={parameter.id}
      render={({ field }) => (
        <Input
          {...field}
          label={parameter.title}
          type={parameter.format === 'password' ? parameter.format : 'text'}
        />
      )}
    />
  ));
}

const GatewayCredentials = ({ isLoading, parameters }) =>
  isLoading ? (
    <Skeleton />
  ) : (
    <Card>
      <CardSection noSpacing>
        <div className="cr-pl-3 cr-pr-4 cr-pt-4 cr-pb-4">
          <Group type="vertical">{renderParameters(parameters)}</Group>
        </div>
      </CardSection>
    </Card>
  );

GatewayCredentials.propTypes = {
  isLoading: PropTypes.bool,
  parameters: PropTypes.arrayOf(PropTypes.shape),
};

GatewayCredentials.defaultProps = {
  isLoading: true,
  parameters: [],
};

export default GatewayCredentials;
